import { useUserState } from '@common/context/userContext';
import Box from '@ds/components/layout/Box';
import Flex from '@ds/components/layout/Flex';
import Typography from '@ds/components/typography/Typography';
import React from 'react';

const UserCard: React.FC = () => {
    const [{ user }] = useUserState();

    return (
        <Flex direction="column">
            <Box pb={1}>
                <Typography variant="body-2">Logged in as</Typography>
            </Box>
            {user?.claims?.firstName && user?.claims.lastName && (
                <Typography variant="body-1">{user.claims.firstName + ' ' + user.claims.lastName}</Typography>
            )}
            {user?.claims?.email && <Typography variant="label-2">{user.claims.email}</Typography>}
        </Flex>
    );
};

export default UserCard;
